import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [logoUrl, setLogoUrl] = useState(null);
  const [companyName, setCompanyName] = useState('Presage REIT\'s Control');
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    fetchSiteInfo();
  }, []);

  const fetchSiteInfo = async () => {
    try {
      const [logoRes, companyRes, menuRes] = await Promise.all([
        axios.get(`${API_URL}/api/site/logo-info`).catch(() => null),
        axios.get(`${API_URL}/api/company-info`).catch(() => null),
        axios.get(`${API_URL}/api/site/menu`).catch(() => null)
      ]);

      if (logoRes?.data?.has_logo) {
        const url = `${API_URL}/api/site/logo`;
        setLogoUrl(url);
        const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.href = url;
        document.head.appendChild(link);
      }

      if (companyRes?.data?.company_name) {
        setCompanyName(companyRes.data.company_name);
        document.title = companyRes.data.company_name;
      }

      if (menuRes?.data?.items) {
        setMenuItems(menuRes.data.items);
      }
    } catch (err) {
      // silent
    }
  };

  return (
    <SiteContext.Provider value={{ logoUrl, companyName, menuItems, refresh: fetchSiteInfo }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) return { logoUrl: null, companyName: 'Presage REIT\'s Control', menuItems: [], refresh: () => {} };
  return context;
};
